import {
    createMessageId,
    EMPTY_SOURCES,
    QuinnRole,
    QuinnRuntimeEventType,
    type QuinnMessage,
    type QuinnRuntimeEvent,
} from "../types";

export function createStreamingQuinnAnswer(): QuinnMessage {
    return {
        id: createMessageId(),
        role: QuinnRole.Quinn,
        content: "",
        createdAt: new Date().toISOString(),
        isStreaming: true,
        trace: [],
        sources: EMPTY_SOURCES,
        prompt: null,
        error: null,
        runId: null,
        rating: null,
    };
}

export function createUserMessage(content: string): QuinnMessage {
    return {
        id: createMessageId(),
        role: QuinnRole.User,
        content,
        createdAt: new Date().toISOString(),
        isStreaming: false,
        trace: [],
        sources: EMPTY_SOURCES,
        prompt: null,
        error: null,
        runId: null,
        rating: null,
    };
}

export function findPrecedingUserContent(messages: QuinnMessage[], messageId: string): string | null {
    const index = messages.findIndex((entry) => entry.id === messageId);
    for (let cursor = index - 1; cursor >= 0; cursor -= 1) {
        if (messages[cursor]?.role === QuinnRole.User) {
            return messages[cursor].content;
        }
    }
    return null;
}

export function applyRuntimeEvent(message: QuinnMessage, event: QuinnRuntimeEvent): QuinnMessage {
    switch (event.type) {
        case QuinnRuntimeEventType.ChatStarted:
            return message;
        case QuinnRuntimeEventType.StepStarted:
            return { ...message, trace: [...message.trace, event.step] };
        case QuinnRuntimeEventType.StepFinished:
            return {
                ...message,
                trace: message.trace.map((step) =>
                    step.id === event.stepId
                        ? {
                              ...step,
                              status: event.status,
                              detail: event.detail !== undefined ? event.detail : step.detail,
                              durationMs: event.durationMs ?? step.durationMs,
                              payload: event.payload ?? step.payload,
                          }
                        : step,
                ),
            };
        case QuinnRuntimeEventType.AnswerDelta:
            return { ...message, content: message.content + event.text };
        case QuinnRuntimeEventType.AnswerFinished:
            return {
                ...message,
                isStreaming: false,
                sources: event.sources ?? message.sources,
                prompt: event.prompt ?? null,
                runId: event.runId ?? message.runId,
            };
        case QuinnRuntimeEventType.Error:
            return { ...message, isStreaming: false, error: event.message };
        default: {
            const _exhaustive: never = event;
            return _exhaustive;
        }
    }
}
